<template>
  <div id="home">
    <div v-if="kategorien.kategorien && sitemap && autoren && getUserMail != null && typeof getUserMail() != 'undefined'">
      <h1 class="text-center" v-if="autoren.autoren && getUserMail()">{{'Hallo ' + autoren.autoren.find(x => x.mail == getUserMail()).vorname + ', eine Freude 👍'}}</h1>
      <v-divider></v-divider>
      <div v-for="post in sitemap.posts" :key="post.slug">
        <v-card>
            <v-card-title class="title">
                <h5 class="tit">{{ post.title }}</h5>
            </v-card-title>
            <v-card-text class="text">
                <p class="body-1 blackx">{{ post.summary }}</p>
                <v-chip-group column v-if="post.kategorien && kategorien.kategorien">
                  <div v-for="chip in kategorien.kategorien" :key="chip.title"><v-chip color="#686de0" v-if="typeof post.kategorien.find(x => x == chip.slug) != 'undefined'">{{chip.title}}</v-chip></div>
                  <div v-for="autor in autoren.autoren" :key="autor.mail"><v-chip color="#0fb9b1" v-if="typeof post.autoren.find(x => x == autor.mail) != 'undefined'">{{autor.vorname + ' ' + autor.nachname}}</v-chip></div>
                </v-chip-group>
            </v-card-text>
            <v-card-actions>
              <v-btn icon @click="selected.slug = post.slug; selected.title = post.title; dialog2 = true"><v-icon color="#e74c3c">{{del}}</v-icon></v-btn>
              <v-btn icon :to="'/' + post.slug"><v-icon color="#e67e22">{{edit}}</v-icon></v-btn>
            </v-card-actions>
        </v-card>
        <v-divider></v-divider>
      </div>
    </div>
    <v-btn fab large bottom fixed right @click="dialog = true"><v-icon color="#2ecc71">{{plus}}</v-icon></v-btn>
    <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Artikel erstellen</v-card-title>
          <v-text-field class="ml-6 mr-6" v-model="title" label="Titel" single-line></v-text-field>
          <v-text-field class="ml-6 mr-6" v-model="slug" :label="toSlug(title)" single-line></v-text-field>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = false; addPost()">Weiter</v-btn>
            <v-btn color="red darken-1" text @click="dialog = false; title = ''; slug = ''">Schließen</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">Bereits belegt.
        <v-btn color="red" text @click="snackbar = false">Schließen</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog2" max-width="350">
        <v-card>
          <h2 class="pa-5 headline">{{selected.title + ' löschen? Dies ist endgültig.'}}</h2>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog2 = false">Schließen</v-btn>
            <v-btn color="red darken-1" text @click="dialog2 = false; delPost()">Löschen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<style scoped>
a {
  text-decoration: none; /* no underline */
}
.blackx{
  color: black;
}
.title{
    padding-bottom: 0px;
}
.text{
    padding-top: 0px;
}
.tit{
    margin: 0px 0px 0px;
}
</style>

<script>
  import { db } from '../db'
  import { fb } from '../db'
  import { mdiPlus} from '@mdi/js'
  import { mdiDelete} from '@mdi/js'
  import { mdiFileEdit } from '@mdi/js'
  const blog = db.collection('blog');
  const sh = db.collection('shared');
  export default {
    name: 'home',
    firestore: {
      sitemap: blog.doc('sitemap'),
      autoren: sh.doc('autoren'),
      kategorien: blog.doc('kategorien')
    },
    data: () => ({
      sitemap: {},
      autoren: {},
      kategorien: {},
      plus: mdiPlus,
      dialog: false,
      dialog2: false,
      title: "",
      slug: "",
      snackbar: false,
      del: mdiDelete,
      edit: mdiFileEdit,
      selected: {}
    }),
    methods: {
      toSlug: function(str){
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to   = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      },
      getUserMail: function() {
        if(fb.auth().currentUser == null){
          return null
        }
        return fb.auth().currentUser.email
      },
      addPost: function(){
        if(this.slug == "") {
          this.slug = this.toSlug(this.title)
        }
        if(this.sitemap == null) {
          this.sitemap = {}
        }
        if(typeof this.sitemap.posts == 'undefined') {
          this.sitemap.posts = []
        }
        if(typeof this.sitemap.posts.find(x => x.slug === this.slug) == 'undefined') {
          this.sitemap.posts.push({title: this.title, slug: this.slug})
          blog.doc('sitemap').set({ posts: this.sitemap.posts });
          blog.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.slug + ' erstellt.'}, {merge: true})
          blog.doc(this.slug).set({slug: this.slug, title: this.title, autoren: [this.getUserMail()]}).then(() => {this.$router.push({path: "/" + this.slug}); this.title = ''; this.slug = ''})
        } else {
          this.snackbar = true;
          this.title = '';
          this.slug = '';
        }
       },
       delPost: function() {
        blog.doc(this.selected.slug).get().then(doc => {
          if (doc.exists) {
            db.collection('blog-deleted').doc(this.selected.slug).set(doc.data())
            blog.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.selected.slug + ' gelöscht.'}, {merge: true})
            blog.doc(this.selected.slug).delete();
          }
        })
        this.sitemap.posts = this.sitemap.posts.filter(item => item.slug !== this.selected.slug)
        blog.doc('sitemap').set({ posts: this.sitemap.posts });
        },
    },
    mounted(){
      this.$Progress.finish()
    },
    metaInfo: {
      meta: [
          {
            name: 'description',
            content: 'BlogCMS'
          }
        ]
    }
  }
</script>